import { render } from "./CandidateProfileStatus.vue?vue&type=template&id=224310b7&scoped=true"
import script from "./CandidateProfileStatus.vue?vue&type=script&lang=js"
export * from "./CandidateProfileStatus.vue?vue&type=script&lang=js"

import "./CandidateProfileStatus.vue?vue&type=style&index=0&id=224310b7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-224310b7"]])

export default __exports__